import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["orderedListData", "omitWrappers", "paginationType", "graphqlEntityMap"],
  _excluded2 = ["id", "__typename"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment, useContext } from 'react';
import { MainContext, MainContextProvider } from '@blaze-cms/nextjs-components';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import FullRenderItem from './FullRenderItem';
import ListPagination from '../Pagination';
import { LOAD_MORE } from '../../../../constants';
import { BANNER } from '../../constants';
import Wrapper from '../../../Wrapper';
import { checkIfShouldRenderBanner } from '../helpers';
const FullRender = _ref => {
  let {
      orderedListData,
      omitWrappers,
      paginationType,
      graphqlEntityMap
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const contextProps = useContext(MainContext);
  const pageBuilderID = uuid();
  const {
    parent,
    entity,
    propsToDisplay,
    banner,
    hasBanner
  } = props;
  const bannerProps = banner ? _objectSpread(_objectSpread({
    hasBanner,
    parent,
    entity,
    propsToDisplay
  }, banner), {}, {
    type: BANNER
  }) : null;
  let bannerIndex = 0;
  const WrapperToUse = omitWrappers ? Fragment : Wrapper;
  return /*#__PURE__*/React.createElement(MainContextProvider, {
    value: _objectSpread(_objectSpread({}, contextProps), {}, {
      isPreview: false
    })
  }, /*#__PURE__*/React.createElement(WrapperToUse, {
    className: "list list--full"
  }, orderedListData.map((_ref2, i) => {
    let {
        id,
        __typename: dataEntity
      } = _ref2,
      entityProps = _objectWithoutProperties(_ref2, _excluded2);
    const shouldRenderBanner = !!bannerProps && checkIfShouldRenderBanner(i, bannerProps);
    if (shouldRenderBanner) bannerIndex += 1;
    return /*#__PURE__*/React.createElement(FullRenderItem, _extends({
      key: id
    }, props, entityProps, {
      entity: graphqlEntityMap[dataEntity],
      index: i,
      itemId: id,
      pageBuilderID: pageBuilderID,
      entityProps: entityProps,
      shouldRenderBanner: shouldRenderBanner,
      bannerProps: bannerProps,
      bannerIndex: bannerIndex
    }));
  })), paginationType === LOAD_MORE && /*#__PURE__*/React.createElement(ListPagination, _extends({
    paginationType: paginationType
  }, props)));
};
FullRender.propTypes = {
  orderedListData: PropTypes.array.isRequired,
  paginationType: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  propsToDisplay: PropTypes.array.isRequired,
  entity: PropTypes.string.isRequired,
  omitWrappers: PropTypes.bool,
  hasBanner: PropTypes.bool,
  banner: PropTypes.object,
  graphqlEntityMap: PropTypes.object.isRequired
};
FullRender.defaultProps = {
  omitWrappers: false,
  hasBanner: false,
  banner: null
};
export default FullRender;
//# sourceMappingURL=FullRender.js.map